import React from 'react';
import { authRoles } from 'app/auth';

const ActivityLogConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.superAdmin,
	routes: [
		{
			path: '/activity-log',
			component: React.lazy(() => import('./ActivityLog'))
		}
	]
};

export default ActivityLogConfig;
